import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { Tag } from "../Snippet";
import { KPILocal } from "../Chart";

const InfoHeaderBudget = ({ view, title, subtitle, actions, central, local }) => {
    const { t } = useTranslation();

    return (
        <Box className={"info-header info-header-wizard info-header-" + view}>
            <Box className={"info-wrapper"}>

                <Tag size="small" color="secondary">{t('WIZARD')}</Tag>
                <span className="title">{title}</span>
                <span className="subtitle">{subtitle}</span>
                {actions}


            </Box>
            <Box className={"kpi-wrapper"}>
                <KPILocal title="Centrale" translate={false} icon={"faGlobe"} score={central} format={"currency"} className="chic" style={{minWidth:'260px'}} />
                <KPILocal title="Locale" translate={false} icon={"faShop"} score={local} format={"currency"} className="chic" style={{minWidth:'260px'}} />
            </Box>
        </Box>
    )
}

export default InfoHeaderBudget;